import '../../css/about-me.module.scss';

function AboutMe(props) {
  return (
    <section className="content">
      <h1 id="about-me">About Me</h1>
      <p>My interests are ideas that shape our lives, sports/science, tech/web stuff, medicine, the food I eat, and coaching tennis..</p>
    </section>
  );
}

export default AboutMe;
